import { render, staticRenderFns } from "./serviceUser.vue?vue&type=template&id=67f000ac&scoped=true&"
import script from "./serviceUser.vue?vue&type=script&lang=js&"
export * from "./serviceUser.vue?vue&type=script&lang=js&"
import style0 from "./serviceUser.vue?vue&type=style&index=0&id=67f000ac&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67f000ac",
  null
  
)

export default component.exports